<template>
  <div>
    <v-button class="reactivate-button" :disabled="!params.enabled">
      <span class="sr-only">{{ getAriaText(params) }} {{ params.srText }}</span>
      <i class="fas fa-redo reactivate-icon"></i>
    </v-button>
  </div>
</template>

<script>
// TODO switch to <font-awesome-icon>

import { library as fontAwesomeLibrary } from '@fortawesome/fontawesome-svg-core';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
fontAwesomeLibrary.add(faPlus);
import { getAriaText } from '@utils/helpers';

export default {
  name: 'alerts-reactivate-button-render',
  computed: {
    parent() {
      return this.params.context;
    }
  },
  methods: {
    getAriaText,
    onDelete() {
      this.parent.onDeleteAlertClicked(this.params.data.triggerId);
    }
  }
};
</script>

<style lang="scss"></style>
